var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-dialog',{ref:"dialog",on:{"hide":_vm.onDialogHide}},[_c('RecorderVoice',{model:{value:(_vm.voice),callback:function ($$v) {_vm.voice=$$v},expression:"voice"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }